export const getSelectedId = state => state.menu.selectedId;
export const getCategory = state => state.menu.category;
export const getDisabledIds = state => state.menu.disabled;
export const manualUpdateButtonActive = state =>
  state.menu.manualUpdateButtonActive;
